import React from 'react';
import { Card } from '@mafc/trolly';
import FONTFAMILY from 'theme/fontFamily';

const CartLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <Card
    as="ul"
    elevation={0}
    width="auto"
    p={0}
    backgroundColor="transparent"
    style={{ fontFamily: FONTFAMILY.PRIMARY }}
    position="relative"
  >
    {children}
  </Card>
);

export default CartLayout;
